function findPlanByLegacyId(plansSTM = [], plans, legacyId) {
  const [planId, period] = legacyId.split('>')
  const periods = {
    '3-months': 90,
    '6-months': 180,
    '12-months': 364
  }

  return {
    id: plansSTM.find(id => plans[id].legacyId === planId),
    period: periods[period],
    hasChanged: false
  }
}

export default findPlanByLegacyId
